// ======================================================================
// File Name       : ContentSubQuestionDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form, FormControl, Col, Button, Modal } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';

class ContentSubQuestionDialog extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.okClick = this.okClick.bind(this);
    this.validation = this.validation.bind(this);
  }

  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.subQuestionTemplate[name] = value;
    } else {
      this.subQuestionTemplate[event] = data;
    }
    this.props.updateSubQuestionTemplate(this.subQuestionTemplate);
  }

  okClick() {
    if (this.validation()) {
      this.props.onOkClick(this.subQuestionTemplate);
    }
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      show,
      subQuestionIndex,
      subQuestionSecernId,
      subAbsolutePoint,
      onCancelClick,
      subQuestionArray,
    } = this.props;
    this.refsToValidate = [];
    this.subQuestionTemplate = {
      subQuestionIndex,
      subQuestionSecernId: subQuestionSecernId || '',
      subAbsolutePoint: subAbsolutePoint || '',
    };
    const isOverlapSubSecernId =
      subQuestionArray &&
      subQuestionArray.filter(
        (item, index) =>
          index !== subQuestionIndex && item.subQuestionSecernId === subQuestionSecernId,
      ).length > 0;
    return (
      <Modal show={show} animation={false}>
        <Modal.Header onHide={onCancelClick} closeButton>
          <Modal.Title className="text-center">
            小問を追加してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="padding-left-20 padding-right-20">
            <Form className='form-horizontal'>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  小問識別ID
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    type="text"
                    name="subQuestionSecernId"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    label={'小問識別ID'}
                    value={subQuestionSecernId}
                    onChange={this.onChange}
                    maxLength={64}
                    validateType={VALIDATE_TYPE.ID_CHECKOVERLAP}
                    isOverlap={isOverlapSubSecernId}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  配点
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    type="text"
                    name="subAbsolutePoint"
                    value={subAbsolutePoint}
                    onChange={this.onChange}
                    maxLength="3"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    validateType={VALIDATE_TYPE.MAX_NUMBER}
                    maxNumber="100"
                    label="配点"
                  />
                </Col>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="default" key={0} className="btn-96" onClick={onCancelClick}>
            {'キャンセル'}
          </Button>
          <Button variant="primary" key={1} className="btn-96" onClick={this.okClick}>
            {'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ContentSubQuestionDialog;
